module.exports = __webpack_public_path__ + "static/media/preloader-SMALL-PennyMac-Flood.97f87229.gif";